<template>
  <div>
    <h5 class="py-2">{{ title }}</h5>
    <div class="col-md-6 px-1">
      <div class="form-detail">
        <b-table
          class="mb-3 mh-125"
          sticky-header
          responsive
          :items="tableItems"
          :fields="fieldsTable"
          :fixed="true"
          :bordered="true"
          details-td-class="details-cell"
        >
          <template #cell(code)="{ item }">
            <p>
              {{ item.code ?? '' }}
            </p>
          </template>
          <template #cell(time)="{ item }">
            <p>Ngày tạo : {{ item.dateCreate | formatDate('HH:mm, DD/MM/YYYY') }}</p>
          </template>
          <template #cell(numDevices)="{ item }">
            <p class="text-right">{{ item.numDevices ?? 0 }}</p>
          </template>
          <template #cell(price)="{ item }">
            <p class="text-right">{{ item.price | fomatCurrency }}</p>
          </template>
          <template #cell(state)="{ item }">
            <p class="badge" :class="item.state">
              {{ item.state | mapTextStatus(Config.listStatusContract) }}
            </p>
          </template>
          <template #cell(type)="{ item }">
            <p>{{ item.type ?? '' }}</p>
          </template>
          <template #cell(action)="row">
            <b-dropdown
              class="text-center"
              variant="outline-light"
              v-show="row.item.state === 'APPROVED'"
            >
              <b-dropdown-item
                type="button"
                class="dropdown-item"
                @click="handleReCreateReceipt(row.item.appendixId)"
              >
                <i class="bx bx-file"></i>
                Sinh lại phiếu thu
              </b-dropdown-item>
              <b-dropdown-item
                type="button"
                class="dropdown-item"
                @click="handleRejectAppendix(row.item.appendixId)"
              >
                <i class="bx bx-x-circle"></i>
                SA Từ chối
              </b-dropdown-item>
            </b-dropdown>
          </template>
          <template #row-details="{ item }">
            <slot name="row-details" v-bind="item"></slot>
          </template>
        </b-table>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import Config from '@/thirdParty/config'
  import { SalesManagerService } from '@/services/sales-manager.service'
  import { ContractService } from '@/services/contract.service'

  const fieldsTable = [
    { key: 'code', label: 'Số phụ lục', class: 'text-left' },
    {
      key: 'time',
      label: 'Thời gian',
      class: 'text-left',
      thStyle: 'min-width: 210px',
    },
    { key: 'numDevices', label: 'SL thiết bị', thClass: 'text-right', tdClass: 'text-right' },
    {
      key: 'price',
      label: 'Thành tiền',
      thClass: 'text-right',
      tdClass: 'text-right',
    },
    { key: 'state', label: 'Trạng thái', class: 'text-center' },
    { key: 'type', label: 'Hình thức mua TB', class: 'text-center' },
    { key: 'action', label: 'Thao tác', class: 'text-center' },
  ]
  export default {
    props: {
      title: {
        type: String,
        default: 'Phụ lục gia hạn sim',
      },
      items: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        Config,
        rowStates: {},
        fieldsTable,
        showLoading: false,
      }
    },
    computed: {
      tableItems() {
        return this.items.map(item => ({
          ...item,
          _showDetails: true,
        }))
      },
    },
    methods: {
      async handleReCreateReceipt(appendixId) {
        try {
          this.showLoading = true
          const response = await SalesManagerService.reCreateReceipt({ appendixId })
          if (response.code === 1000) {
            this.$emit('change')
            this.showSuccessMx(response.message)
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error.message || error.response?.message || error.response?.data?.message)
        } finally {
          this.showLoading = false
        }
      },
      async handleRejectAppendix(appendixId) {
        const { value: flag, note } = await this.rejectMx('Nhập lý do từ chối')
        if (!flag) return
        if (!note) {
          this.showFailMx('Vui lòng nhập lý do từ chối')
          return
        }
        const params = {
          reasonAddInfo: [note],
          appendixActionType: 'APPENDIX_ACTION_REJECT',
          appendixId,
        }
        try {
          this.showLoading = true
          const response = await ContractService.actionAppendix(params)
          if (response.code === 1000) {
            this.$emit('change')
            this.showSuccessMx(response.message)
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error.message || error.response?.message || error.response?.data?.message)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
